import {
    NOTIFICATION_FAILED,
    NOTIFICATION_FETCHING,
    NOTIFICATION_SUCCESS,
} from "../../Constants.ts";

export interface NotiState {
    isFetching: boolean;
    isError: boolean;
    result: any;
}

const initialState: NotiState = {
    isFetching: false,
    isError: false,
    result: null,
};

export default (state = initialState, { type, payload }: any): NotiState => {
    switch (type) {
        case NOTIFICATION_FETCHING:
            return { ...state, isFetching: true, isError: false, result: null };
        case NOTIFICATION_SUCCESS:
            return { ...state, isFetching: false, isError: false, result: payload };
        case NOTIFICATION_FAILED:
            return { ...state, isFetching: false, isError: true, result: null };
        default:
            return state;
    }
};
